<template>
  <div v-bind="$attrs" @click="handleClick">
    <ChatBubbleBottomCenterTextIcon class="main-mobile-footer-icon" aria-hidden="true" />
    <div class="main-mobile-footer-caption">{{ t('Help?') }}</div>
  </div>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useLocale } from '@/plugins/i18n'

import { useHubspot } from '@/plugins/hubspot'

import { useModalsStore } from '@/store/modals'

import HubspotUnavailableModal from '../../components/HubspotUnavailableModal.vue'

import { ChatBubbleBottomCenterTextIcon } from '@heroicons/vue/24/outline'

const { t } = useLocale('layouts.Main')

const hubspot = useHubspot()
const modalsStore = useModalsStore()

const handleClick = () => {
  if (hubspot?.isLoaded) {
    hubspot.open()
  } else {
    const modalInstance = modalsStore.init(
      'hubspot-unavailable',
      markRaw(HubspotUnavailableModal)
    )
    modalInstance?.open(modalsStore.getZIndex())
  }
}
</script>
